module.exports = __webpack_public_path__ + "media/images/promotions/cards/fate-1-f1ead84125d417619db0c46e2f67313a.svg";